import { MessageReduxType } from "../constant/Types";

export const msg = {
  id: null,
  hashCode: null,
  fileId: null,
  url: null,
  sessionId: null,
  messageType: null,
  fileUrl: null,
  filename: null,
  text: null,
  userId: null,
  created: null,
  ownerType: null,
  subscriber: {},
  voiceDuration: 0,
  me: true,
};

const initialize = {
  data: [],
  loading: false,
};

export default function pdfMessages(state = initialize, action) {
  switch (action.type) {
    case MessageReduxType.addBulk:
      return {
        ...state,
        data: action.data.sort((a, b) => a.created - b.created),
      };
    case MessageReduxType.add:
      const newData = action.data;
      return {
        ...state,
        data: { ...state.data, newData },
      };
    case MessageReduxType.loading:
      return {
        ...state,
        loading: action.data,
      };
    default:
      return state;
  }
}
